<template src="./index.html"></template>

<script>

export default {
  data: function () {
    return {
      tableData: {
        qbxse: "88495.58",
        rjcpxse: "88495.58",
        frjcpxse: "0.00",
        qbxxse: "11504.42",
        rjcpxxse: "11504.42",
        qbjxse: "722.56",
        kdkse: "722.56",
        rjjxse: "130.93",
      },
      data: {
        suosq: "2019年09期",
        companyName: "上海速元信息技术有限公司",
        writeTime: "2019年10月18日",
        writeInstructions: "1、《申请软件产品增值税“即征即退”企业全部销项税额明细表》（以下简称“表一”）\r\n2、《申请软件产品增值税“即征即退”企业全部进项税额明细表》（以下简称“表二”）\r\n3、第1行=“表一”中的“全部销售额”一栏中的合计数；  4、第2行=“表一”中“软件产品销售额”一栏合计数；5、第3行=第1行-第2行；\r\n6、第4行=上期《资产负债表》存货一栏期末数；7、第5行=本期购进或生产数；8、第6行=4+5-7，特殊情况请企业附上具体说明； \r\n9、第7行=当期《资产负债表》存货一栏期末数；10、第8行=[第3行-第6行]÷第6行；    11、第9行=“表一”中的“全部销项税额”一栏中的合计数；\r\n12、第10行=“表一”中的“软件产品销项税额”一栏中的合计数；    13、第11行=“表二”中的“全部进项税额”一栏中的合计数；\r\n14、第12行、第13行须同《增值税纳税人申报表》第13项、第14项相一致；    15、第14行=第11行+第12行-第13行；\r\n16、第15行能单独计算自行开发生产软件产品进项税额的按实际发生额填列（“表二”中“软件进项税额”一栏合计数），否则第15行=第14行×第2行÷第1行；\r\n17、纯软件产品3至8行不需填列；18、此表一式一份随同《软件产品增值税即征即退申请表》一并上报。",
      }
    };
  },
  created() {
  },
  mounted() {
  },
  components: {},
  methods: {
  },
};
</script>

<style scoped lang="less">
@import url("./index.less");
</style>
